import XEUtils from 'xe-utils';
export function toStringTimeDate(str) {
    if (str) {
        var rest = new Date();
        var h = 0;
        var m = 0;
        var s = 0;
        if (XEUtils.isDate(str)) {
            h = str.getHours();
            m = str.getMinutes();
            s = str.getSeconds();
        }
        else {
            str = XEUtils.toValueString(str);
            var parses = str.match(/^(\d{1,2})(:(\d{1,2}))?(:(\d{1,2}))?/);
            if (parses) {
                h = XEUtils.toNumber(parses[1]);
                m = XEUtils.toNumber(parses[3]);
                s = XEUtils.toNumber(parses[5]);
            }
        }
        rest.setHours(h);
        rest.setMinutes(m);
        rest.setSeconds(s);
        return rest;
    }
    return new Date('');
}
export function getDateQuarter(date) {
    var month = date.getMonth();
    if (month < 3) {
        return 1;
    }
    else if (month < 6) {
        return 2;
    }
    else if (month < 9) {
        return 3;
    }
    return 4;
}
